import React, { useState } from 'react'
import {
    Card, H5, H6, Divider, Row, Col, Tabs, Tab, FormikInput, FormikSimpleSelect,
    SaveButton, Form, ResetButton, DailyYardageProNav, FormikDate
} from '../../Elements'
import { GuniteHistoryRow } from '../Job/JobForm/SharedGuniteForm'
import { Icon, NonIdealState } from '@blueprintjs/core'
import { Prompt } from 'react-router-dom'
import _, { isEqualWith } from 'lodash'
import { useMediaQuery } from 'react-responsive'
import { AddressLinkText } from "../../Elements/Address";
import moment from 'moment'

const iconStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '20px'
}
const vTabStyle = {
    whiteSpace: 'normal',
    width: '120px',
    minHeight: '50px',
    lineHeight: '20px',
    marginBottom: '10px',
    border: '1px solid'
}


const _getTabTitle = (sub_job) => {
    if (sub_job && sub_job.job_category) {
        let job_types = sub_job.job_types &&
            sub_job.job_types.map(j => j.name).join(', ')

        let date = sub_job.job_category.id === 1 && sub_job.gunite_details.finished_date

        return <span>
            {job_types ? <p>{job_types}</p> : <p>No Job Types</p>}
            {date ? <p>{date}</p> : <p>No Date</p>}
        </span>
    }
}

export const DailyYardageForm = ({ values, jobStatuses, jobOrders, guniteHistoryTypes, crews, setFieldValue, guniteHistoryEntryJobStatuses, ...props }) => {
    const indexOfFirstGuniteSubjob = values.sub_jobs && values.sub_jobs.indexOf(values.sub_jobs.find(sj => sj.job_category && sj.job_category.id === 1))
    const DEFAULT_SUB_TAB = `sub_jobs-${indexOfFirstGuniteSubjob}`

    const [tabState, setTabState] = useState(DEFAULT_SUB_TAB)
    const [sidebarVisible, setSidebarState] = useState(true)
    const colStyle = !sidebarVisible ? { display: 'none' } : {}
    const isMobile = useMediaQuery({ query: '(max-width: 800px)' })

    return <Form>
        <Prompt
            when={!props.isSubmitting && !isEqualWith(values, props.initialValues, (newValue, oldValue, key) => {
                if (!newValue && !oldValue) return true
            })}
            message={'You have unsaved changes. Navigate away?'}
        />
        <Row>
            <Col lg={12}>
                <Card>
                    <span style={{ 'float': 'right' }}>
                        <ResetButton onClick={props.onCancel} isMobile={isMobile} />
                        <SaveButton style={{ float: 'right' }} isMobile={isMobile} />
                        <DailyYardageProNav />
                    </span>
                    <H5>{values.company.company_name} - {values.name}</H5>
                    <H6>Order Id: {values.id}</H6>
                    <AddressLinkText
                        line1={values.address_line_1}
                        line2={values.address_line_2}
                        city={values.city}
                        state={values.state}
                        zip={values.zip_code}
                    />
                </Card>
            </Col>
        </Row>
        <Divider />
        {indexOfFirstGuniteSubjob === -1
            ? <NonIdealState
                icon='issue'
                title='This job does not contain any Gunite Records'
            />
            : <Card>
                <Row>
                    {!sidebarVisible && <Icon
                        icon='caret-right'
                        iconSize='20'
                        onClick={() => setSidebarState(true)}
                    />
                    }
                    <Col lg={1} style={colStyle}>
                        <div style={iconStyle}>
                            <Icon icon='caret-left' iconSize='20'
                                onClick={() => setSidebarState(false)} />
                        </div>
                        <Tabs
                            id="job_detail_tab"
                            onChange={setTabState}
                            selectedTabId={tabState}
                            style={vTabStyle}
                            vertical
                        >
                            {values.sub_jobs && values.sub_jobs.map((sub_job, idx) => {
                                return sub_job.job_category && sub_job.job_category.id === 1 && (
                                    <Tab
                                        style={vTabStyle}
                                        id={`sub_jobs-${idx}`}
                                        key={`sub_jobs-${idx}`}
                                        title={_getTabTitle(sub_job)}
                                    />
                                )
                            })}
                        </Tabs>
                    </Col>
                    <Col lg={11}>
                        {values.sub_jobs && values.sub_jobs.map((sub_job, idx) => {
                            const valuePrefix = `sub_jobs[${idx}]`
                            return (
                                sub_job.job_category && sub_job.job_category.id === 1 &&
                                tabState === `sub_jobs-${idx}` &&
                                <Card>
                                    <Row>
                                        <Col lg={6}>
                                            <FormikSimpleSelect
                                                name={`${valuePrefix}.status`}
                                                label='Status'
                                                items={jobStatuses}
                                                nullable
                                                listenerComponents={[
                                                    {
                                                        componentName: `${valuePrefix}.awaiting_builder_date`,
                                                        componentNewValueCalculator: (a, b, c) => {
                                                            return b?.id !== 19 ?
                                                                c.awaiting_builder_date = null
                                                                : c.awaiting_builder_date = moment().format('YYYY-MM-DD')
                                                        },
                                                        supportingProps: {
                                                            awaiting_builder_date: sub_job.awaiting_builder_date
                                                        }
                                                    },
                                                    {
                                                        componentName: `${valuePrefix}.gunite_details.finished_date`, componentNewValueCalculator: (a, b, c) => {
                                                            if (b && b.id && b.id === 1 && (sub_job.gunite_details.finished_date == null || sub_job.gunite_details.finished_date === '')) {
                                                                //Find non-boulder, flash or other gunite history entry with the most recent date
                                                                const mostRecentEntry = _.maxBy(c.gunite_history_entries?.filter(e => e.type?.id < 9
                                                                    && e.gunite_date !== null & e.gunite_date !== ''), (e) => { return e.gunite_date })
                                                                return mostRecentEntry?.gunite_date

                                                            } else {
                                                                return sub_job.gunite_details.finished_date
                                                            }
                                                        }, supportingProps: {
                                                            gunite_history_entries: sub_job.gunite_details?.gunite_history

                                                        }
                                                    },
                                                ]}
                                            />
                                            <FormikDate
                                                name={`${valuePrefix}.gunite_details.finished_date`}
                                                label='Finished Date'
                                            />
                                            {sub_job.status?.id === 19 &&
                                                <FormikDate
                                                    name={`${valuePrefix}.awaiting_builder_date`}
                                                    label='Awaiting Builder Date'
                                                />}
                                        </Col>
                                        <Col lg={6}>
                                            <FormikInput
                                                name={`${valuePrefix}.mmg_perimeter`}
                                                label='MMG Perimeter'
                                            />
                                            <FormikInput
                                                name={`${valuePrefix}.gunite_details.total_yardage`}
                                                label='Total Yardage'
                                                key={`gunite_details_yardage_${values.sub_jobs[idx].gunite_details.total_yardage}`}
                                            />
                                            <FormikInput
                                                name={`${valuePrefix}.gunite_details.flash_yards`}
                                                label='Flash Yards'
                                                key={`gunite_details_flash_${values.sub_jobs[idx].gunite_details.flash_yards}`}
                                            />
                                        </Col>
                                    </Row>
                                    <GuniteHistoryRow
                                        values={sub_job}
                                        valuePrefix={valuePrefix}
                                        isMobile={isMobile}
                                        crews={crews}
                                        guniteHistoryTypes={guniteHistoryTypes}
                                        jobOrders={jobOrders}
                                        setFieldValue={setFieldValue}
                                        jobStatuses={guniteHistoryEntryJobStatuses}
                                    />
                                </Card>
                            )
                        }
                        )}
                    </Col>
                </Row>
            </Card>
        }
    </Form>
}